import { securityGroupsSecurityReducer } from 'src/app/admin/security-groups/store/reducers/security.reducer';

export const securityGroupsReducers = {
    securityState: securityGroupsSecurityReducer
};
